import React, { useEffect, useState } from "react";
import { CustomTab, EmptyScreen, Loader } from "../../../Components/Other";
import {
  CustomSearchInput,
  // CustomSelectMenu,
  SelectBasket,
} from "../../../Components/FormElements";
import { useNavigate } from "react-router-dom";
import { BasketCard } from "../../../Components/Card";
import { APIService } from "../../../Service";

export default function MappedBaskets({ basketData, basketColors }) {
  const navigate = useNavigate();
  const [riskTabData, setRiskTabData] = useState([]);
  const [tenureTabData, setTenureTabData] = useState([]);
  const [searchValueRisk, setSearchValueRisk] = useState("");
  const [searchValueTenure, setSearchValueTenure] = useState("");
  const [curRiskTab, setCurRiskTab] = useState(1);
  const [curTenureTab, setCurTenureTab] = useState(1);
  const [selectedRiskBasket, setSelectedRiskBasket] = useState([]);
  const [selectedTenureBasket, setSelectedTenureBasket] = useState([]);
  const [filteredBasket, setFilteredBaskets] = useState([]);
  const [recommendedRisk, setRecommendedRisk] = useState("");
  const [recommendedTenure, setRecommendedTenure] = useState("");

  const [loading, setLoading] = useState(false);
  const [isEmpty, setIsEmpty] = useState({ risk: false, tenure: false });

  useEffect(() => {
    _getFilterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLoading(true);
    _getBaskets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curRiskTab, curTenureTab]);

  //service to get filterData
  const _getFilterData = () => {
    const is_post = false;
    APIService(is_post, "manage-basket/filter-data")
      .then((response) => {
        if (response.status_code === 200) {
          setRiskTabData(renameKey(response.data.investment_style));
          setTenureTabData(renameKey(response.data.tenure));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //service to get filtered baskets
  const _getBaskets = () => {
    const is_post = true;
    const payload = {
      investment_style: curRiskTab,
      tenure: curTenureTab,
    };
    APIService(is_post, "manage-basket/list-mapping", payload)
      .then((response) => {
        if (response.status_code === 200) {
          if (response.data.risk_baskets.length === 0) {
            setIsEmpty((prev) => ({ ...prev, risk: true }));
          } else {
            setIsEmpty((prev) => ({ ...prev, risk: false }));
          }
          if (response.data.tenure_baskets.length === 0) {
            setIsEmpty((prev) => ({ ...prev, tenure: true }));
          } else {
            setIsEmpty((prev) => ({ ...prev, tenure: false }));
          }
          setFilteredBaskets(response.data);
          setSelectedRiskBasket(response.data.risk_baskets);
          setSelectedTenureBasket(response.data.tenure_baskets);
          setRecommendedRisk(getRec(response.data.risk_baskets));
          setRecommendedTenure(getRec(response.data.tenure_baskets));
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const extractId = (e) => {
    if (e === null || e === undefined) return null;
    if (typeof e === "object")
      return Number(e.basket_style_id ?? e.value ?? e.id);
    return Number(e);
  };
  //service to update mapping

  const _updateMapping = () => {
    setLoading(true);
    const is_post = true;

    const riskIds =
      selectedRiskBasket
        ?.map(extractId)
        .filter((id) => !isNaN(id) && id !== null) ?? [];
    const tenureIds =
      selectedTenureBasket
        ?.map(extractId)
        .filter((id) => !isNaN(id) && id !== null) ?? [];

    const payload = {
      investment_style_id: curRiskTab,
      tenure_id: curTenureTab,
      risk_baskets: riskIds,
      recommended_risk_basket: isNaN(Number(recommendedRisk))
        ? Number(getRec(filteredBasket.risk_baskets))
        : Number(recommendedRisk),
      tenure_baskets: tenureIds,
      recommended_tenure_basket: isNaN(Number(recommendedTenure))
        ? Number(getRec(filteredBasket.tenure_baskets))
        : Number(recommendedTenure),
    };

    setSearchValueRisk("");
    setSearchValueTenure("");

    APIService(is_post, "manage-basket/update-mapping", payload)
      .then((response) => {
        if (response.status_code === 200) {
          _getBaskets();
          setRecommendedRisk("");
          setRecommendedTenure("");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getRec = (basket) => {
    // eslint-disable-next-line
    const e = basket.find((e) => {
      if (e.is_recommended) return e.basket_style_id;
    });
    return e?.basket_style_id;
  };

  const renameKey = (arr) =>
    arr.map(({ value, ...rest }) => ({ ...rest, id: value }));

  const createMap = (basket) => {
    const newMap = new Map(
      basket.map((e) => [e.basket_style_id, e.basket_style_id]),
    );
    return newMap;
  };

  // const getFilterName = (data, tab) => {
  //   const d = data.find((e) => e.id === tab)?.label || "";
  //   return d;
  // };

  const getFilteredBasketOptions = (basketData, searchValue) => {
    return basketData.filter((e) =>
      e.name?.trim().toLowerCase().includes(searchValue.toLowerCase()),
    );
  };
  return (
    <div className="row e-pt-20px">
      <div className="col-md-8 col-12 d-flex row-gap-3 flex-column">
        <div className="row">
          <div className="col-12">
            <div className="d-flex flex-column e-border-1px-pale-lavender row-gap-3 e-border-radius-16 p-3 e-bg-ghost-white-dark w-100">
              <div className="d-flex flex-column">
                <h4 className=" e-font-16 e-font-weight-600 e-primary-font-poppins line-height-24 pb-2">
                  Risk category
                </h4>
                {/* custom tab  */}
                <div className="e-customer-tab d-flex flex-nowrap justify-content-between align-items-center e-border-1px-bottom-pale-lavender ">
                  <div className="d-flex column-gap-2 e-primary-font-poppins">
                    {riskTabData.map((data, index) => (
                      <CustomTab
                        key={index}
                        type={1}
                        borderRadius="border-radius-4"
                        tabData={data}
                        tabIndex={curRiskTab}
                        background="bg-white"
                        handleChange={() => setCurRiskTab(data.id)}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <CustomSearchInput
                type="text"
                id="search"
                placeholder={`Search for basket `}
                className="w-100 e-search-input-padding "
                value={searchValueRisk}
                handleChange={setSearchValueRisk}
                onKeyPress={() => {
                  //   _getFundsList();
                }}
              />
              {searchValueRisk !== "" && (
                <SelectBasket
                  options={getFilteredBasketOptions(
                    basketData,
                    searchValueRisk,
                  )}
                  prevSelected={createMap(filteredBasket.risk_baskets)}
                  recommended={recommendedRisk}
                  setRecommended={setRecommendedRisk}
                  value={selectedRiskBasket}
                  onChange={setSelectedRiskBasket}
                  type={3}
                  isMulti={true}
                  onPress={_updateMapping}
                />
              )}
              <div className="row row-cols-2  row-gap-3">
                {loading ? (
                  <div className="d-flex w-100 h-100 align-items-center justify-content-center">
                    <Loader width={30} />
                  </div>
                ) : isEmpty.risk ? (
                  <div className="w-100">
                    <EmptyScreen message="Data Not Found" width="100px" />
                  </div>
                ) : (
                  filteredBasket?.risk_baskets?.map((item, index) => {
                    const color = basketColors[index % basketColors.length]; // repeat colors
                    return (
                      <div className="col d-flex" key={index}>
                        <BasketCard
                          type={item.is_recommended ? 3 : 1}
                          title={item.name}
                          img={item.image}
                          content={item.description}
                          returns={`${item.return_percentage} (${item.return_year})`}
                          bgColor={color.bgColor}
                          borderColor={color.borderColor}
                          badges={item.features}
                          handleView={() =>
                            navigate(
                              `/manage-basket/detail/${item.basket_style_id}`,
                            )
                          }
                        />
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="d-flex flex-column e-border-1px-pale-lavender row-gap-3 e-border-radius-16 p-3 e-bg-ghost-white-dark w-100">
              <div className="d-flex flex-column">
                <h4 className=" e-font-16 e-font-weight-600 e-primary-font-poppins line-height-24 pb-2">
                  Tenure category
                </h4>
                {/* custom tab  */}
                <div className="e-customer-tab d-flex flex-nowrap justify-content-between align-items-center e-border-1px-bottom-pale-lavender ">
                  <div className="d-flex column-gap-2 e-primary-font-poppins">
                    {tenureTabData.map((data, index) => (
                      <CustomTab
                        key={index}
                        type={1}
                        borderRadius="border-radius-4"
                        tabData={data}
                        tabIndex={curTenureTab}
                        background="bg-white"
                        handleChange={() => setCurTenureTab(data.id)}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <CustomSearchInput
                type="text"
                id="search"
                placeholder={`Search for basket `}
                className="w-100 e-search-input-padding "
                value={searchValueTenure}
                handleChange={setSearchValueTenure}
                onKeyPress={() => {
                  //   _getFundsList();
                }}
              />
              {searchValueTenure !== "" && (
                <SelectBasket
                  options={getFilteredBasketOptions(
                    basketData,
                    searchValueTenure,
                  )}
                  recommended={recommendedTenure}
                  setRecommended={setRecommendedTenure}
                  value={selectedTenureBasket}
                  onChange={setSelectedTenureBasket}
                  type={3}
                  isMulti={true}
                  onPress={_updateMapping}
                />
              )}
              <div className="row row-cols-2  row-gap-3">
                {loading ? (
                  <div className="d-flex w-100 h-100 align-items-center justify-content-center">
                    <Loader width={30} />
                  </div>
                ) : isEmpty.tenure ? (
                  <div className="w-100">
                    <EmptyScreen message="Data Not Found" width="100px" />
                  </div>
                ) : (
                  filteredBasket?.tenure_baskets?.map((item, index) => {
                    const color = basketColors[index % basketColors.length]; // repeat colors
                    return (
                      <div className="col d-flex" key={index}>
                        <BasketCard
                          type={item.is_recommended ? 3 : 1}
                          title={item.name}
                          img={item.image}
                          recommended={item.is_recommended}
                          content={item.description}
                          returns={`${item.return_percentage} (${item.return_year})`}
                          bgColor={color.bgColor}
                          borderColor={color.borderColor}
                          badges={item.features}
                          handleView={() =>
                            navigate(
                              `/manage-basket/detail/${item.basket_style_id}`,
                            )
                          }
                        />
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
